import Axios from "axios";
import * as config from "@/constants/config";
import { authHeader } from "@/services/TokenHelper";
import ConstantsValues from "../constants/constants";

export default {
  controller: "authentication/",
  register: "register",
  authenticate: "login",
  reset: "reset",
  requestreset: "requestreset",
  Login: function(loginUser) {
    loginUser.product = ConstantsValues.Products.Admin;

    return Axios.post(
      config.API + this.controller + this.authenticate,
      loginUser,
      { headers: authHeader() }
    );
  },
  CreateNewUser: function(newUser) {
    return Axios.post(config.API + this.controller + this.register, newUser, {
      headers: authHeader()
    });
  },
  ResetPassword: function(resetToken) {
    return Axios.post(config.API + this.controller + this.reset, resetToken, {
      headers: authHeader()
    });
  },
  RequestPasswordChange: function(resetRequest) {
    resetRequest.product = ConstantsValues.Products.Admin;

    return Axios.post(
      config.API + this.controller + this.requestreset,
      resetRequest,
      { headers: authHeader() }
    );
  }
};
